<template>
  <div id="pagesAdminWrapper">
    <div class="columns">
      <div v-if="pages.length > 0" class="column is-half">
        <div v-for="page in pages" :key="page.id" class="box">
          <article class="media">
            <div class="media-left">
              <i class="fa fa-2x" :class="(page.view_mode === 'grid') ? 'fa-grip-horizontal' : 'fa-stream'"></i>
            </div>

            <div class="media-content">
              <nav class="level is-mobile is-pulled-right">
                <div class="level-left">
                  <options-buttons @edit="edit(page.id)" @delete="remove(page.id)"></options-buttons>
                </div>
              </nav>

              <div class="content">
                <p>
                  <strong>{{ page.name }}</strong>
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div v-else class="notification">
        Er zijn nog geen contentpagina's bij deze tabel.
      </div>

      <div class="column is-half">
        <create-button
          caption="Nieuwe contentpagina"
          @click="toggle">
        </create-button>
      </div>
    </div>

    <create-page
      :tableId="this.$route.params.tableId"
      :isActive="isActive"
      @close="toggle">
    </create-page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreatePage from '@/components/pages/CreatePage'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  components: {
    CreatePage,
    CreateButton,
    OptionsButtons
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      pages: 'pages/pages'
    })
  },
  created () {
    this.$store.dispatch('pages/loadAll', this.$attrs.tableId)
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    },
    edit (pageId) {
      this.$router.push({
        name: 'page-admin',
        params: {
          id: pageId
        }
      })
    },
    remove (pageId) {
      this.$store.dispatch('pages/remove', pageId)
    }
  }
}
</script>
